import { sendMagicLink } from "../../visitWidgetApi";
import { AppDispatch } from "@store/store";
import { logError } from "@lib/logger";
import { setAuthViewAction } from "@store/sessionReducer";

/*
 * Resend magic link
 */
const resendMagicLinkAction =
  ({ email }: { email: string | null }) =>
  async (dispatch: AppDispatch) => {
    if (email === null) {
      // TODO: this could be better, something is off in our app if email is null at this stage
      dispatch(setAuthViewAction({ authView: "signInEmail" }));
    } else {
      try {
        await sendMagicLink({ email });
        dispatch(setAuthViewAction({ authView: "magicLinkSent" }));
      } catch (error) {
        logError(error);
        dispatch(setAuthViewAction({ authView: "signInEmail" }));
      }
    }
  };

export { resendMagicLinkAction };
